<template>
	<div :class="getStatusHeader.header.minimaze ? 'grid__content' : 'grid__content-minimaze grid__content'">
        <div class="grid__navigator">
			<chat-navigator :activeRooms="activeRooms" :activePrivateRoom="activePrivateRooms" :activaTeam="activaTeam"/>
        </div>
	    <div class="grid__main-content">
			<chat-messages @changeRooms="setRooms($event)"/>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChatNavigator from './chat/chat-navigator.vue';
import ChatMessages from './chat/chat-messages.vue';

export default {
	components: {
		'chat-navigator': ChatNavigator,
		'chat-messages': ChatMessages
    },
	props: [],
	data() {
		return {
            chatRooms: [
                {
                    title:'Общая',
                    id:'GENERAL',
                    avatar:require('../assets/img/common_room.png'),
                },
                {
                    title:'EUR/USD',
                    id:'GxPdourxnLZTn8bS3',
                    avatar: require('../assets/img/EUR-USD.png')
                },
                {
                    title:'GBP/USD',
                    id:'SzTxmGjZ3Ls7meHip',
                    avatar: require('../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/JPY',
                    id:'quNyJDfKMLbtD2Cpd',
                    avatar: require('../assets/img/JPY-USD.png')
                },
                {
                    title:'EUR/GBP',
                    id:'qnyBnbnoXAphn9Tyq',
                    avatar: require('../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/CAD',
                    id:'oYDdSLr8Ko4cjkAqR',
                    avatar: require('../assets/img/USD-CAD.png')
                },
                {
                    title:'AUD/USD',
                    id:'rxJCXtWfTWM2DxSWD',
                    avatar: require('../assets/img/AUD-USD.png')
                },
                {
                    title:'NZD/USD',
                    id:'FyHkn552jTt392MjM',
                    avatar: require('../assets/img/NZD-USD.png')
                },
                {
                    title:'USD/CHF',
                    id:'GgaShiX8ebRZxT5j4',
                    avatar: require('../assets/img/USD-CHF.png')
                },

            ],
            privateRooms: {
            chatPrivateRooms: [
                    {
                        title:'Алексей Денисов',
                        subtitle:'Управляющий трейдер',
                        id:'aldenisov',
                        avatar:require('../assets/img/adenisov.png'),
                    },
                    {
                        title:'СЛУЖБА КОМПЛАЕНС',
                        subtitle:'',
                        id:'vd_iqquantum_com',
                        avatar: require('../assets/img/common_room.png'),
                        mail:'compliance@iqquantum.com'
                    }, 
                ],
            consultPrivateRooms: [
                    {
                        title:'Леонид Фролов',
                        subtitle:'Консультант',
                        id:'lfrolov_iqquantum_com',
                        avatar:require('../assets/img/user_avatar.jpg'),
                        mail:'lfrolov@iqquantum.com',
                        tel:'+7 (903) 807-71-17'
                    }
                ],
                partnerPrivateRooms: [
                    {
                        title:'Алексей Степанов',
                        subtitle:'Партнёр',
                        id:'as_iqquantum_com',
                        avatar:require('../assets/img/user_avatar.jpg'),
                        mail:'as@iqquantum.com',
                        tel:'+7 (920) 165-01-24'
                    }
                ],
            },
            activaTeam:'Команда',
            activeRooms: [
                {
                    title:'Общая',
                    id:'GENERAL',
                    avatar:require('../assets/img/common_room.png'),
                },
                {
                    title:'EUR/USD',
                    id:'GxPdourxnLZTn8bS3',
                    avatar: require('../assets/img/EUR-USD.png')
                },
                {
                    title:'GBP/USD',
                    id:'SzTxmGjZ3Ls7meHip',
                    avatar: require('../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/JPY',
                    id:'quNyJDfKMLbtD2Cpd',
                    avatar: require('../assets/img/JPY-USD.png')
                },
                {
                    title:'EUR/GBP',
                    id:'qnyBnbnoXAphn9Tyq',
                    avatar: require('../assets/img/GBP-USD.png')
                },
                {
                    title:'USD/CAD',
                    id:'oYDdSLr8Ko4cjkAqR',
                    avatar: require('../assets/img/USD-CAD.png')
                },
                {
                    title:'AUD/USD',
                    id:'rxJCXtWfTWM2DxSWD',
                    avatar: require('../assets/img/AUD-USD.png')
                },
                {
                    title:'NZD/USD',
                    id:'FyHkn552jTt392MjM',
                    avatar: require('../assets/img/NZD-USD.png')
                },
                {
                    title:'USD/CHF',
                    id:'GgaShiX8ebRZxT5j4',
                    avatar: require('../assets/img/USD-CHF.png')
                },

            ],
            activePrivateRooms: [
                    {
                        title:'Алексей Денисов',
                        subtitle:'Управляющий трейдер',
                        id:'aldenisov',
                        avatar:require('../assets/img/adenisov.png'),
                    },
                    {
                        title:'СЛУЖБА КОМПЛАЕНС',
                        subtitle:'',
                        id:'vd_iqquantum_com',
                        avatar: require('../assets/img/common_room.png'),
                        mail:'compliance@iqquantum.com'
                    }, 
            ]
        }
	},
	computed: {
		...mapGetters({
	        	chatMessages: 'chat/messages',
                chatErrors: 'chat/errors',
                getStatusHeader:'usersets/getSettings',
               }),
        
	},
	methods: {
		connect() {
			this.$store.dispatch('chat/connect');
		},
		login() {
			this.$store.dispatch('chat/login');
		},
		enterRoom() {
			this.$store.dispatch('chat/enterRoom');
		},
		sendMessage() {
			let text = $(this.$refs.msgInput).val();
			this.$store.dispatch('chat/sendMessage', text);	
        },
        setRooms(e) {
            if(e.public !== null)
                this.activeRooms = this[e.public];
            else
                this.activeRooms = null;
            if(e.private !== null && e.private !== 'directRoom')
                this.activePrivateRooms = this.privateRooms[e.private];
            else 
                this.activePrivateRooms = null;
            if(e.private === 'directRoom')
                this.activePrivateRooms = 'directRoom';
            this.activaTeam = e.nameTeam;
        }
	},
};
</script>

<style scoped lang="less">
	@workarea-color: #F2F2F2;	
</style>